import React, { FC, useCallback, useContext, useState } from "react";
import {
    View,
    Text,
    FlatList,
    StyleSheet,
    ScrollView,
    Image,
    ToastAndroid,
    RefreshControl,
} from "react-native";
import { Context } from '../../contexts/feed/Store';

import SingleFeed from './SingleFeed';
import VisitModal from '../modals/VisitModal';
import AddEditCartItemModal from '../modals/AddEditCartItemModal';
import FontStyles from "../../constants/FontStyle";
import Colors from "../../constants/Colors";
import { IProduct } from "../../interfaces/product";
import { GetPricetag } from "../../constants/Utils";
import { useFocusEffect } from "@react-navigation/native";

const Feed: FC = function () {

    const [state, dispatch, fetch] = useContext(Context);

    const [visitData, setVisitData]: [any, any] = React.useState(null);
    const [isVisitModalOpen, setVisitModalOpen] = React.useState(false);

    const [selectedProduct, setSelectedProduct]: [any, any] = React.useState(null);
    const [isCartModalOpen, setCartModalOpen] = React.useState(false);

    const [refresh, setRefresh] = React.useState(false)
    const onRefresh = () => {
        setRefresh(true)
        fetch().then(() => {
            setRefresh(false)
        }).catch(() => {
            setRefresh(false)
        })
    }

    const hideModal = () => {
        setVisitModalOpen(false)
        setVisitData(null)
    }

    const openVisitModal = (props: any) => {
        setVisitData({})
        const promotion = state.feeds.find((item: any) => item._id === props.data.promotion_id)
        if (!promotion) return null
        const visitData = Object.assign({}, {
            promotion,
            data: props.data
        })
        setVisitData(visitData)
        setVisitModalOpen(true)
    }

    const hideAddCartModal = () => {
        setCartModalOpen(false)
        setSelectedProduct(null)
    }
    const openCartModal = (product: IProduct) => {
        if (product && product.sellers) {
            let pricetag = GetPricetag(product)
            if (pricetag) {
                product['pricetag'] = pricetag
                setCartModalOpen(true)
                setSelectedProduct(product)
            }
        }
    }

    const RenderFeed: FC<{ item: any }> = ({ item }) => {
        return <SingleFeed
            openVisitModal={openVisitModal}
            openCartModal={openCartModal}
            {...item}
        />
    }

    let feeds = (
        <ScrollView style={{ paddingHorizontal: 16, paddingTop: 16 }}>
            <View style={styles.dummyFeedCard}></View>
            <View style={styles.dummyFeedCard}></View>
        </ScrollView>
    )

    if (state.error) {
        feeds = (
            <ScrollView
                contentContainerStyle={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexGrow: 1
                }}
                refreshControl={
                    <RefreshControl
                        refreshing={refresh}
                        onRefresh={() => onRefresh()}
                    />
                }
            >
                <Image source={require('../../assets/images/main/Folder.png')} style={{
                    width: 53,
                    height: 41,
                    paddingVertical: 12.56,
                    paddingHorizontal: 8.5,
                    marginBottom: 8
                }} />
                <Text style={{
                    // height: 19,
                    // width: 139,
                    ...FontStyles.dark,
                    ...FontStyles.size16,
                    ...FontStyles.lh20,
                    ...FontStyles.bold,
                    marginBottom: 10,
                }}>Your feed is empty!</Text>
                <Text style={{
                    // height: 18,
                    // width: 261,
                    color: Colors.shades._7,
                    ...FontStyles.size13,
                    ...FontStyles.lh18,
                    ...FontStyles.normal,
                }}>There's nothing to display here. Pull down to refresh.</Text>
            </ScrollView>
        );
    }

    if (!state.error && state.feeds) {
        feeds = (
            <>
                <FlatList
                    initialNumToRender={3}
                    data={state.feeds}
                    renderItem={RenderFeed}
                    keyExtractor={item => item._id}
                    style={{ paddingHorizontal: 16, paddingTop: 16 }}
                    refreshControl={
                        <RefreshControl
                            refreshing={refresh}
                            onRefresh={() => onRefresh()}
                        />
                    }
                />
            </>
        )
    }

    useFocusEffect(
        useCallback(() => {
            fetch().then(() => { }).catch(() => { })
            return () => {}
        }, [])
    )

    return (
        <View style={[styles.container, { flexGrow: 1, backgroundColor: '#f6f7fc', paddingBottom: 16 }]} >
            {
                visitData && <VisitModal
                    isActive={isVisitModalOpen}
                    {...visitData}
                    hideModal={hideModal}
                />
            }
            {
                selectedProduct && <AddEditCartItemModal
                    modalState={isCartModalOpen}
                    product={selectedProduct}
                    hideModal={hideAddCartModal}
                    navigateAway={false}
                />
            }
            {feeds}
        </View>
    )
}

export default Feed

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fff',
    },
    dummyFeedCard: {
        height: 370,
        width: '100%',
        borderRadius: 10,
        backgroundColor: '#FFFFFF',
        marginBottom: 16,
        // box-shadow: 0 2px 4px 0 rgba(234,238,239,0.8);
    }
})